var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338.531 338.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.413 275.866l-139.2-239.6c-6.4-10.8-15.6-17.2-25.2-17.2-10 0-19.2 6.4-25.2 17.2l-138.4 239.6c-6.4 10.8-7.2 22-2 30.4 4.8 8.4 14.8 13.2 27.6 13.2h276.8c12.4 0 22.4-4.8 27.6-13.2 4.8-8.4 4-19.6-2-30.4zm-13.2 22c-2 3.2-6.4 4.8-12.8 4.8h-276.8c-6.4 0-11.2-2-12.8-4.8-2-3.2-1.2-8 2-13.6l138.4-239.6c3.2-5.6 7.2-8.8 10.8-8.8 3.6 0 7.6 3.2 10.8 8.8l138.4 239.6c3.2 5.6 4 10.4 2 13.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.013 97.866c-4.8 0-8.4 3.6-8.4 8.4v111.2c0 4.8 3.6 8.4 8.4 8.4s8.4-3.6 8.4-8.4v-111.2c0-4.8-3.6-8.4-8.4-8.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.013,
    cy: 259.466,
    r: 14.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.cc98b0150effbbee392746763299249a.svg";
export { ForwardRef as ReactComponent };